[
  {
    "id": "GET-M8P-L304-001",
    "module": "Getalbegrip",
    "difficulty": 304,
    "question": "Een auto rijdt 1 op 15. Hoeveel liter benzine is nodig voor 450 km?",
    "options": [
      "30 liter",
      "25 liter",
      "35 liter",
      "45 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen_verbruik",
    "familyId": "GET-VERHOUDING",
    "explanation": "450 : 15 = 30. Je hebt 30 liter nodig.",
    "distractorExplanations": {
      "1": "Je deelde 450 door 18 in plaats van door 15. '1 op 15' betekent 15 km per liter.",
      "2": "Je deelde 450 door 13 in plaats van door 15. Controleer: 15 $\\times$ 30 = 450.",
      "3": "Je deelde 450 door 10. Maar de auto rijdt 1 op 15, niet 1 op 10."
    }
  },
  {
    "id": "GET-M8P-L304-002",
    "module": "Getalbegrip",
    "difficulty": 304,
    "question": "Reken uit: $\\frac{1}{2}$ $\\times$ $\\frac{1}{3}$ $\\times$ $\\frac{1}{4}$ =",
    "options": [
      "$\\frac{1}{24}$",
      "$\\frac{1}{9}$",
      "$\\frac{3}{24}$",
      "$\\frac{1}{12}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vermenigvuldigen",
    "familyId": "GET-BREUK-KEER",
    "explanation": "Teller: 1 $\\times$ 1 $\\times$ 1 = 1. Noemer: 2 $\\times$ 3 $\\times$ 4 = 24. Dus $\\frac{1}{24}$.",
    "distractorExplanations": {
      "1": "Je telde de noemers op (2 + 3 + 4 = 9) in plaats van ze te vermenigvuldigen. Bij breuken vermenigvuldigen doe je noemer $\\times$ noemer.",
      "2": "Je telde de tellers op (1 + 1 + 1 = 3) in plaats van ze te vermenigvuldigen. 1 $\\times$ 1 $\\times$ 1 = 1.",
      "3": "Je vergat de laatste breuk ($\\frac{1}{4}$). $\\frac{1}{2}$ $\\times$ $\\frac{1}{3}$ = $\\frac{1}{6}$, maar je moet nog keer $\\frac{1}{4}$ doen."
    }
  },
  {
    "id": "GET-M8P-L304-003",
    "module": "Getalbegrip",
    "difficulty": 304,
    "question": "Wat is het kwadraat van 15?",
    "options": [
      "225",
      "215",
      "250",
      "30"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "kwadraten",
    "familyId": "GET-MACHTEN",
    "explanation": "15 $\\times$ 15 = 225. Tip: 15² = (10 + 5)² = 100 + 2 $\\times$ 50 + 25 = 225.",
    "distractorExplanations": {
      "1": "Je maakte een vermenigvuldigingsfout. 15 $\\times$ 15 = 225, niet 215. Controleer: 15 $\\times$ 10 = 150, 15 $\\times$ 5 = 75, samen 225.",
      "2": "Je schatte te hoog. 15 $\\times$ 15 = 225, niet 250. 250 zou het kwadraat zijn van een getal tussen 15 en 16.",
      "3": "Je vermenigvuldigde 15 met 2 in plaats van met zichzelf. Het kwadraat van 15 is 15 $\\times$ 15, niet 15 $\\times$ 2."
    }
  },
  {
    "id": "GET-M8P-L304-004",
    "module": "Getalbegrip",
    "difficulty": 304,
    "question": "Schrijf 5% als breuk (vereenvoudigd).",
    "options": [
      "$\\frac{1}{20}$",
      "$\\frac{1}{5}$",
      "$\\frac{5}{100}$",
      "$\\frac{1}{50}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten_breuk",
    "familyId": "GET-PROC-BEREKENEN",
    "explanation": "5% = $\\frac{5}{100}$. Deel teller en noemer door 5: $\\frac{1}{20}$.",
    "distractorExplanations": {
      "1": "$\\frac{1}{5}$ = 20%. Dat is vier keer zoveel als 5%. Je deelde door 20 in plaats van door 5.",
      "2": "$\\frac{5}{100}$ is wel correct, maar niet vereenvoudigd. Deel teller en noemer allebei door 5.",
      "3": "$\\frac{1}{50}$ = 2%. Je deelde de noemer door 2 in plaats van door 5."
    }
  },
  {
    "id": "GET-M8P-L304-005",
    "module": "Getalbegrip",
    "difficulty": 304,
    "question": "Reken uit: -5 - -8 =",
    "options": [
      "3",
      "-13",
      "-3",
      "13"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "negatieve_getallen",
    "familyId": "GET-NEGATIEF",
    "explanation": "Min min wordt plus. -5 - -8 = -5 + 8 = 3.",
    "distractorExplanations": {
      "1": "Je rekende -5 + -8 = -13. Maar 'min min' wordt plus! Dus -5 - (-8) = -5 + 8.",
      "2": "Je draaide de berekening om: 5 - 8 = -3. Maar het is -5 + 8 = 3 (positief).",
      "3": "Je rekende 5 + 8 = 13. Bijna goed, maar vergeet het minteken niet: -5 + 8 = 3."
    }
  }
]